<script setup lang="ts">
const props = defineProps<{
  color: string;
}>();
</script>
<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="none"
  >
    <g clip-path="url(#clip0_1392_5631)">
      <path
        d="M9.99992 0.833984C11.2155 0.833984 12.3813 1.31687 13.2408 2.17641C14.1004 3.03595 14.5833 4.20174 14.5833 5.41732C14.5833 6.63289 14.1004 7.79868 13.2408 8.65822C12.3813 9.51777 11.2155 10.0007 9.99992 10.0007C8.78434 10.0007 7.61855 9.51777 6.75901 8.65822C5.89947 7.79868 5.41658 6.63289 5.41658 5.41732C5.41658 4.20174 5.89947 3.03595 6.75901 2.17641C7.61855 1.31687 8.78434 0.833984 9.99992 0.833984ZM9.99992 19.1673C9.99992 19.1673 19.1666 19.1673 19.1666 16.8757C19.1666 14.1256 14.6978 11.1465 9.99992 11.1465C5.302 11.1465 0.833252 14.1256 0.833252 16.8757C0.833252 19.1673 9.99992 19.1673 9.99992 19.1673Z"
        :fill="color"
      />
    </g>
    <defs>
      <clipPath id="clip0_1392_5631">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
